// export const API_BASE_URL = "https://vt-hospitals-svc.onrender.com/vthospitals";
// export const SECURITY_API_BASE_URL = "https://vt-hospitals-security-svc.onrender.com/vtsecurity";

export const API_BASE_URL = "https://vthospitalssvc.param.cloud/vthospitals";
export const SECURITY_API_BASE_URL = "https://security.param.cloud/vtsecurity";

//export const API_BASE_URL = "http://localhost:8080/vthospitals";
//export const SECURITY_API_BASE_URL = "http://localhost:8082/vtsecurity";
export const AXIOS_COMMON_URL = "http://localhost:8080";

const ENDPOINTS = {
    SAVE_PRESCRIPTION: `${API_BASE_URL}/savePrescription`,
    REGISTER_AND_SCHEDULE_APPOINTMENT: `${API_BASE_URL}/registerPatientAndScheduleAppointment`,
    REGISTER_AND_ADMIT_PATIENT: `${API_BASE_URL}/registerPatientAndAdmitPatient`,
    UPDATE_PATIENT: `${API_BASE_URL}/updatePatient`,
    GET_INITIAL_REGISTRATION_DATE: `${API_BASE_URL}/getInitialRegistrationDate`,

    GET_TOTAL_OP_APPOINTMENTS_COUNT_BY_DATE: `${API_BASE_URL}/getTotalOPAppointmentsCountByDate`,
    GET_TOTAL_IP_ADMISSIONS_COUNT_BY_DATE: `${API_BASE_URL}/getTotalIPAdmissionsCountByDate`,
    GET_TOTAL_OUTPATIENTS_COUNT_BY_DATE: `${API_BASE_URL}/getTotalOutPatientsCountByDate`,
    GET_TOTAL_INPATIENTS_COUNT_BY_DATE: `${API_BASE_URL}/getTotalInPatientsCountByDate`,
    GET_TOTAL_COLLECTION: `${API_BASE_URL}/getTotalCollection`,

    GET_DAILY_APPOINTMENTS_COUNT: `${API_BASE_URL}/getDailyAppointmentsCount`,
    GET_DAILY_ADMISSIONS_COUNT: `${API_BASE_URL}/getDailyAdmissionsCount`,
    GET_TOTAL_OP_APPOINTMENTS_COUNTOFDOCTOR_BYDATE: `${API_BASE_URL}/getTotalOPAppointmentsCountOfDoctorBydate`,
    GET_TOTAL_IP_ADMISSIONS_COUNTOFDOCTOR_BYDATE: `${API_BASE_URL}/getTotalIPAdmissionsCountOfDoctorBydate`,

    GET_ADMISSIONS_TREND_TYPEWISEBY_DATE: `${API_BASE_URL}/getAdmissionsTrendTypeWiseByDate`,
    GET_ADMISSIONS_TREND_STATUSWISEBY_DATE: `${API_BASE_URL}/getAdmissionsTrendStatusWiseByDate`,

    GET_TOTAL_PRESCRIPTIONS_COUNT_BY_DATE: `${API_BASE_URL}/getTotalPrescriptionsCountByDate`,
    GET_TOTAL_PATIENTS_COUNT_BY_DATE: `${API_BASE_URL}/getTotalPatientsCountByDate`,

    GET_DAILY_PRESCRIPTIONS_COUNT: `${API_BASE_URL}/getDailyPrescriptionsCount`,
    GET_TOTAL_PRESCRIPTIONS_COUNT_OF_DOCTOR: `${API_BASE_URL}/getTotalPrescriptionsCountOfDoctor`,
    GET_PRESCRIPTIONS_TREND_TYPEWISE_BY_DATE: `${API_BASE_URL}/getPrescriptionsTrendTypeWiseByDate`,


    GET_BILL_CLEARANCE: `${API_BASE_URL}/getBillClearance`,
    ADD_PAYMENT_TO_INVOICE: `${API_BASE_URL}/addPaymentToInvoice`,
    PROCESS_REFUND: `${API_BASE_URL}/processRefund`,
    CREATE_INVOICES: `${API_BASE_URL}/createInvoices`,

    GET_PRESCRIBED_MEDICINES_BY_PRESCRIPTIONID: `${API_BASE_URL}/getPrescribedMedicinesByPrescriptionId`,
    DELETE_PRESCRIPTION: `${API_BASE_URL}/deletePrescription`,
    ADD_CHARGES: `${API_BASE_URL}/addCharges`,
    UPDATE_CHARGE: `${API_BASE_URL}/updateCharge`,
    DELETE_CHARGE: `${API_BASE_URL}/deleteCharge`,
    APPLY_DISCOUNT_TO_INVOICE: `${API_BASE_URL}/applyDiscountToInvoice`,
    GET_CHARGES_BY_ADMISSIONID: `${API_BASE_URL}/getChargesByAdmissionId`,
    GET_TOTAL_AMOUNT_BY_ADMISSIONID_AND_CHARGETYPE: `${API_BASE_URL}/getTotalAmountByAdmissionIdAndChargeType`,
    GET_INVOICE_SUMMARY_FOR_IP: `${API_BASE_URL}/getInvoiceSummaryForIP`,

    GET_ADMISSION_DETAILS_BY_ADMISSION_ID: `${API_BASE_URL}/getAdmissionDetailsByAdmissionId`,
    GET_IP_PAYMENT_HISTORY: `${API_BASE_URL}/getIpPaymentHistory`,
    SEARCH_ADMISSIONS_BY_FILTERS: `${API_BASE_URL}/searchAdmissionsByFilters`,
    SEARCH_APPOINTMENTS_BY_FILTERS: `${API_BASE_URL}/searchAppointmentsByFilters`,
    SEARCH_PRESCRIPTIONS_BY_FILTERS: `${API_BASE_URL}/searchPrescriptionsByFilters`,

    GET_PRESCRIPTION_INVOICES_OF_AN_ADMISSION: `${API_BASE_URL}/getPrescriptionInvoicesOfAnAdmission`,

    GET_ALL_PATIENTS_WITH_APPOINTMENTS: `${API_BASE_URL}/getAllPatientsWithAppointments`,
    POST_UPLOAD_DOCUMENT_IN_ADMISSION: `${API_BASE_URL}/uploadDocument`,
    GET_BILL_CLEARANCE: `${API_BASE_URL}/getBillClearance`,
    GET_ALL_PATIENTS_WITH_ADMISSIONS: `${API_BASE_URL}/getAllPatientsWithAdmissions`,
    GET_APPOINTMENT_DETAILS_BY_APPOINTMENT_ID: `${API_BASE_URL}/getAppointmentDetailsByAppointmentId`,
    GET_APPOINTMENT_REPORT: `${API_BASE_URL}/getAppointmentReport`,
    GET_OP_CHARGES_REPORT: `${API_BASE_URL}/getOpChargesReport`,



    LOGIN: `${SECURITY_API_BASE_URL}/login`,
    VALIDATE: `${SECURITY_API_BASE_URL}/validate`,
    LOGOUT: `${SECURITY_API_BASE_URL}/logout`,

    // ─── Hospital Floor Management ────────────────────────────────────────────
    // CRUD for physical floors in the hospital building (IP Manage → Rooms tab)
    GET_ALL_FLOORS: `${API_BASE_URL}/floors`,
    ADD_FLOOR: `${API_BASE_URL}/floors`,
    UPDATE_FLOOR: (id) => `${API_BASE_URL}/floors/${id}`,
    DELETE_FLOOR: (id) => `${API_BASE_URL}/floors/${id}`,

    // ─── Hospital Room Management ─────────────────────────────────────────────
    // CRUD for individual rooms/beds within each floor
    GET_ALL_ROOMS: `${API_BASE_URL}/rooms`,
    GET_ALL_DOCTORS: `${API_BASE_URL}/getAllDoctors`,
    GET_ROOMS_BY_FLOOR: (floorId) => `${API_BASE_URL}/rooms?floorId=${floorId}`,
    ADD_ROOM: `${API_BASE_URL}/rooms`,
    UPDATE_ROOM: (id) => `${API_BASE_URL}/rooms/${id}`,
    TOGGLE_ROOM_STATUS: (id) => `${API_BASE_URL}/rooms/${id}/toggleStatus`,
    DELETE_ROOM: (id) => `${API_BASE_URL}/rooms/${id}`,

    // ─── Room Types Management ────────────────────────────────────────────────
    // CRUD for configured room categories in the hospital (mapped to room_types table)
    GET_ALL_ROOM_TYPES: `${API_BASE_URL}/room-types`,
    GET_ACTIVE_ROOM_TYPES: `${API_BASE_URL}/room-types/active`,
    GET_ROOM_TYPE_BY_ID: (id) => `${API_BASE_URL}/room-types/${id}`,
    ADD_ROOM_TYPE: `${API_BASE_URL}/room-types`,
    UPDATE_ROOM_TYPE: (id) => `${API_BASE_URL}/room-types/${id}`,
    TOGGLE_ROOM_TYPE_STATUS: (id) => `${API_BASE_URL}/room-types/${id}/toggle-status`,
    DELETE_ROOM_TYPE: (id) => `${API_BASE_URL}/room-types/${id}`,

    // ─── Bed Types Management ─────────────────────────────────────────────────
    // CRUD for configured bed types in the hospital (mapped to bed_types table)
    GET_ALL_BED_TYPES: `${API_BASE_URL}/bed-types`,
    GET_ACTIVE_BED_TYPES: `${API_BASE_URL}/bed-types/active`,
    GET_BED_TYPE_BY_ID: (id) => `${API_BASE_URL}/bed-types/${id}`,
    ADD_BED_TYPE: `${API_BASE_URL}/bed-types`,
    UPDATE_BED_TYPE: (id) => `${API_BASE_URL}/bed-types/${id}`,
    TOGGLE_BED_TYPE_STATUS: (id) => `${API_BASE_URL}/bed-types/${id}/toggle-status`,
    DELETE_BED_TYPE: (id) => `${API_BASE_URL}/bed-types/${id}`,

    // ─── Room Type Charge Configs (Billing Rules) ─────────────────────────────
    // One billing rule config per room type (frequency, thresholds, half-day)
    GET_ALL_CHARGE_CONFIGS: `${API_BASE_URL}/room-charges/configs`,
    GET_CHARGE_CONFIG: (roomType) => `${API_BASE_URL}/room-charges/configs/${encodeURIComponent(roomType)}`,
    UPSERT_CHARGE_CONFIG: `${API_BASE_URL}/room-charges/configs`,

    // ─── Room Type Charge Items (Line Items) ──────────────────────────────────
    // Individual charge templates per room type (e.g., "ICU → NURSING FEES: ₹500/day")
    GET_ALL_CHARGE_ITEMS: `${API_BASE_URL}/room-charges/items`,
    GET_CHARGE_ITEMS_BY_TYPE: (roomType) => `${API_BASE_URL}/room-charges/items?roomType=${encodeURIComponent(roomType)}`,
    GET_ACTIVE_CHARGE_ITEMS: (roomType) => `${API_BASE_URL}/room-charges/items/active?roomType=${encodeURIComponent(roomType)}`,
    ADD_CHARGE_ITEM: `${API_BASE_URL}/room-charges/items`,
    UPDATE_CHARGE_ITEM: (id) => `${API_BASE_URL}/room-charges/items/${id}`,
    // ─── Inpatient Services Management ───────────────────────────────────────
    // CRUD for configured inpatient services (mapped to inpatient_services table)
    GET_ALL_INPATIENT_SERVICES: `${API_BASE_URL}/inpatient-services`,
    GET_INPATIENT_SERVICE_BY_ID: (id) => `${API_BASE_URL}/inpatient-services/${id}`,
    ADD_INPATIENT_SERVICE: `${API_BASE_URL}/inpatient-services`,
    UPDATE_INPATIENT_SERVICE: (id) => `${API_BASE_URL}/inpatient-services/${id}`,
    TOGGLE_INPATIENT_SERVICE_STATUS: (id) => `${API_BASE_URL}/inpatient-services/${id}/toggle-status`,
    DELETE_INPATIENT_SERVICE: (id) => `${API_BASE_URL}/inpatient-services/${id}`,

    // ─── Pharmacy Suppliers Management ─────────────────────────────────────────
    // Endpoints for fetching, creating, updating, toggling status, and deleting suppliers
    GET_ALL_SUPPLIERS: `${API_BASE_URL}/suppliers`,
    GET_SUPPLIER_COUNTS: `${API_BASE_URL}/suppliers/counts`,
    GET_SUPPLIER_BY_ID: (id) => `${API_BASE_URL}/suppliers/${id}`,
    ADD_SUPPLIER: `${API_BASE_URL}/suppliers`,
    UPDATE_SUPPLIER: (id) => `${API_BASE_URL}/suppliers/${id}`,
    TOGGLE_SUPPLIER_STATUS: (id) => `${API_BASE_URL}/suppliers/${id}/toggleStatus`,
    DELETE_SUPPLIER: (id) => `${API_BASE_URL}/suppliers/${id}`,

    // ─── Supplier Items Catalog ───────────────────────────────────────────────
    GET_SUPPLIER_ITEMS: (id) => `${API_BASE_URL}/suppliers/${id}/items`,
    GET_ALL_SUPPLIER_ITEMS: (id) => `${API_BASE_URL}/suppliers/${id}/items/all`,
    ADD_SUPPLIER_ITEM: (id) => `${API_BASE_URL}/suppliers/${id}/items`,
    UPDATE_SUPPLIER_ITEM: (id, itemId) => `${API_BASE_URL}/suppliers/${id}/items/${itemId}`,
    DELETE_SUPPLIER_ITEM: (id, itemId) => `${API_BASE_URL}/suppliers/${id}/items/${itemId}`,

    // ─── Supplier Payments & Purchase Entries ─────────────────────────────────
    GET_SUPPLIER_PURCHASE_ENTRIES: (id) => `${API_BASE_URL}/suppliers/${id}/payments/entries`,
    GET_SUPPLIER_PAYMENT_HISTORY: (id) => `${API_BASE_URL}/suppliers/${id}/payments/history`,
    GET_SUPPLIER_PAYMENT_SUMMARY: (id) => `${API_BASE_URL}/suppliers/${id}/payments/summary`,
    RECORD_SUPPLIER_PAYMENT: (id) => `${API_BASE_URL}/suppliers/${id}/payments`,

    // ─── Global Pharmacy Purchase Entries & Stock Management ───────────────────
    GET_ALL_PURCHASE_ENTRIES: `${API_BASE_URL}/purchase-entries`,
    GET_PURCHASE_ENTRIES_METRICS: `${API_BASE_URL}/purchase-entries/metrics`,
    GET_PURCHASE_ENTRY_BY_ID: (id) => `${API_BASE_URL}/purchase-entries/${id}`,
    CREATE_PURCHASE_ENTRY: `${API_BASE_URL}/purchase-entries`,
    UPDATE_PURCHASE_ENTRY: (id) => `${API_BASE_URL}/purchase-entries/${id}`,
    DELETE_PURCHASE_ENTRY: (id) => `${API_BASE_URL}/purchase-entries/${id}`,
    GET_PURCHASE_ENTRY_ITEMS: (id) => `${API_BASE_URL}/purchase-entries/${id}/items`,
    SYNC_PURCHASE_ENTRY_ITEMS: (id) => `${API_BASE_URL}/purchase-entries/${id}/items/sync`,
    SAVE_PURCHASE_ENTRY_ITEM: (id) => `${API_BASE_URL}/purchase-entries/${id}/items`,
    DELETE_PURCHASE_ENTRY_ITEM: (id, itemId) => `${API_BASE_URL}/purchase-entries/${id}/items/${itemId}`,

    // ─── Master Medicines Search & Catalog ────────────────────────────────────
    SEARCH_MEDICINES: `${API_BASE_URL}/medicines/search`,
    CREATE_MEDICINE_ENTRY: `${API_BASE_URL}/medicineDataEntry`,
    GET_ALL_MEDICINES: `${API_BASE_URL}/getAllMedicines`,
    GET_MEDICINE_BATCHES: (id) => `${API_BASE_URL}/medicines/${id}/batches`,
};

export default ENDPOINTS;


